<template>
  <div class="box">
  <div class="top" v-if="type != 'multiple'">
    <div class="title">Selected Publisher</div>
    <div class="bottom">
      <LogoImage
        :maxWidth="'95%'"
        :logoUrl="itemData?.publicImage"
        :brandName="itemData?.creatorName"
        :width="68"
        :height="68"
        :fontSize="14"
      />
      <div class="bottom-title">
        {{ itemData?.creatorName }}
      </div>
    </div>
  </div>
  <div class="content">
    <div class="title">Select Brand</div>
    <div class="table">
      <div class="table-head">
        <a-space>
          <ButtonGroups
            :pagination="pagination"
            :tableData="dataSource"
            @pageChange="onPageChange"
          />
        </a-space>
        <a-space>
          <a-input-search
            v-model:value="value5"
            :placeholder="$t('seller.common.searchPlaceholder')"
            allow-clear
            @search="onSearch"
            @enter="onSearch"
          >
          </a-input-search>
        </a-space>
      </div>
      <div class="filters">
        <div class="filter-item">
          <div class="label">AssociateStatus:</div>
          <artemisads-segmented
            class="segmented"
            v-model:value="filter.associateBrandProgress"
            @change="handleChange"
            :options="['All', 'Active', 'InActive']"
          />
        </div>
        <div class="filter-item">
          <div class="label">ACC Authorization:</div>
          <artemisads-segmented
            class="segmented"
            v-model:value="filter.accAuthorization"
            @change="handleChange"
            :options="['All', 'Authorized', 'Not Authorized']"
          />
        </div>
      </div>
      <div class="table-content">
        <artmisads-table
          :row-selection="{
            selectedRowKeys: selectedRowKeys,
            onChange: onSelectChange,
          }"
          :row-key="(record) => record.id"
          v-model:pagination="pagination"
          :columns="columns"
          :data-source="dataSource"
          :change="onTableChange"
          :loading="loading"
        >
          <template #headerCell="{ column }">
            <template v-if="column.dataIndex === 'ccAuthorizationStatus'">
              <span>
                ACC Authorization
                <a-popover placement="left" trigger="hover">
                  <template #content>
                    <div class="popover-content">
                      <div class="popover-title">
                        Amazon Creator Connections Commission Adjustment Policy
                        (<Icon
                          :name="CURRENCY_MAPPER[amazonCountryCode].icon"
                          class="icon"
                        ></Icon
                        >{{ CURRENCY_MAPPER[amazonCountryCode].host }} Only)
                      </div>
                      <div class="popover-content-text">
                        <p>
                          Upon granting ArtemisAds brand-level permissions to
                          Amazon Creator Connections
                        </p>
                        <p>
                          under your Amazon Seller Central account, our system
                          will automatically detect and
                        </p>
                        <P
                          >reconcile overlapping commission calculations between
                          the Associate program and</P
                        >
                        <P
                          >ACC Campaigns. The following adjustments will then be
                          implemented：</P
                        >
                      </div>
                      <div class="popover-bottom-text">
                        <div class="popover-bottom-text-top">
                          <Status
                            type="delivering"
                            :noBorder="true"
                            style="margin-left: -5px"
                          />
                          If ACC commission rate ≥ ArtemisAds Associate
                          commission rate
                        </div>
                        <div class="popover-bottom-text-bottom">
                          <p>
                            Associate commissions to publishers is not required.
                            （commission = $0）
                          </p>
                          <p>
                            (ArtemisAds platform commission is still required.)
                          </p>
                        </div>
                      </div>
                      <div class="popover-bottom-text-content">
                        <div class="popover-bottom-text-top">
                          <Status
                            type="delivering"
                            :noBorder="true"
                            style="margin-left: -5px"
                          />
                          If ACC commission rate < ArtemisAds Asscoaite
                          commission rate
                        </div>
                        <div class="popover-bottom-text-bottom">
                          <p>Only the difference is paid via ArtemisAds.</p>
                        </div>
                      </div>
                    </div>
                  </template>
                  <Icon name="wenhao-tianchong" class="wenhao" />
                </a-popover>
              </span>
            </template>
          </template>
          <template #bodyCell="{ column, text, record }">
            <template v-if="column.dataIndex === 'brand'">
              <div class="brand-item">
                <LogoImage
                  :maxWidth="'95%'"
                  :logoUrl="record.logoImageUrl"
                  :brandName="record.amazonBrandName"
                  :width="56"
                  :height="56"
                  :fontSize="10"
                  :borderRadius="4"
                />
                <div class="brand-name">{{ record.amazonBrandName }}</div>
              </div>
            </template>
            <template v-else-if="column.dataIndex === 'commissionRate'">
              {{ record.commissionRate }}%
            </template>
            <template v-else-if="column.dataIndex === 'associateStatus'">
              <Status
                :type="record?.associateStatus?.toLowerCase()"
                :noBorder="true"
                :text="
                  record?.associateStatus?.toLowerCase() == 'active'
                    ? 'Active'
                    : 'Inactive'
                "
              />
            </template>
            <template v-else-if="column.dataIndex === 'ccAuthorizationStatus'">
              <div
                class="ccAuthorizationStatus"
                v-if="record?.ccAuthorizationStatus"
              >
                <div 
                class="ccAuthorizationStatus-content"
                :style="{
                  cursor: isAcc ? 'pointer' : 'default',
                }"
                @click="handleChangeAuthorizationStatus(record)">
                  <Status
                  :type="record?.ccAuthorizationStatus?.toLowerCase()"
                  :noBorder="true"
                  :text="
                    capitalize(record?.ccAuthorizationStatus?.toLowerCase())
                  "
                />
                <Icon
                  v-if="record.ccAuthorizationStatus !== 'authorized'&&isAcc"
                  name="tiaozhuan"
                  class="tiaozhuanicon"
                ></Icon>
                </div>
               
              </div>
            </template>
          </template>
        </artmisads-table>
      </div>
    </div>
  </div>
  </div>
  <div class="bottomFix">
    <div class="total">
      Selected Brands ({{ allSelectedKeys.size }} /<span class="totalStyle"
        >{{ pagination.total }}</span
      >)
    </div>
    <div class="bottomFixContent">
      Setting up on
      <Icon :name="CURRENCY_MAPPER[amazonCountryCode].icon" class="icon"></Icon
      >{{ CURRENCY_MAPPER[amazonCountryCode].host }}. For other country stores,
      switch country on the top right.
    </div>
    <div class="bottomFixButton">
      <artmisads-button
        type="default"
        @click="goBack"
         class="next-button"
        v-if="type == 'multiple'"
      >
        Back
      </artmisads-button>
      <artmisads-button
        type="primary"
        @click="goNext"
        :disabled="allSelectedKeys.size === 0"
        class="next-button"
      >
        Next
      </artmisads-button>
    </div>
  </div>
</template>

<script setup>
import { ref, defineProps, defineEmits, onMounted, watch,computed } from 'vue'
import LogoImage from '@/components/LogoImage.vue'
import ButtonGroups from './buttonGroups.vue'
import Status from '@/components/Status.vue'
import { CURRENCY_MAPPER } from '@/contants/common'
import Icon from '@/components/Icon.vue'
import { useSellerBrandStore } from '@/storeData/sellerbrand'
import { useUserInfoStore } from '@/storeData/index'
import { publishersApi, brandApi } from '@/server'
import { message } from 'ant-design-vue'
import { countBrandNames } from '~/utils'
import { capitalize } from '~/utils'
import { useRouter } from 'vue-router'

import { useSystemStore } from '@/storeData/system'
const systemStore = useSystemStore()
const isAcc = computed(() => systemStore.isAcc)
console.log(isAcc.value,'数据')
const router = useRouter()
const props = defineProps(['type', 'selectedBrands', 'selectedRowKeysId'])
const loading = ref(false)
const amazonCountryCode = ref('')
const store = useUserInfoStore()
const userInfo = store.userInfo
let amazonUserId
const brandStore = useSellerBrandStore()
watch(
  () => userInfo.countryCode,
  () => {
    amazonCountryCode.value = userInfo.countryCode
  },
  { immediate: true },
)
// Define props
const pagination = ref({
  total: 0,
  defaultPageSize: 10,
  current: 1,
  showSizeChanger: true,
  pageSize: 10,
  pageSizeOptions: ['10', '20', '30', '40', '50'],
})
const selectedRowKeys = ref([]) // 当前页面显示的选中项
const allSelectedKeys = ref(new Set()) // 所有页面的选中项集合
const allSelectedBrands = ref(new Map()) // 存储所有选中品牌的完整数据
const filter = ref({
  associateBrandProgress: 'All',
  accAuthorization: 'All',
})

// Watch for changes in selectedRowKeysId and selectedBrands props
watch(
  [() => props.selectedRowKeysId, () => props.selectedBrands],
  ([newSelectedRowKeysId, newSelectedBrands]) => {
    if (newSelectedRowKeysId && newSelectedRowKeysId.length > 0) {
      allSelectedKeys.value = new Set(newSelectedRowKeysId)
      if (newSelectedBrands && newSelectedBrands.length > 0) {
        newSelectedBrands.forEach(brand => {
          allSelectedBrands.value.set(brand.id, brand)
        })
      }
    }
  },
  { deep: true, immediate: true }
)
const columns = ref([
  {
    title: 'Brand',
    dataIndex: 'brand',
    key: 'brand',
  },
  {
    title: 'Amazon SellerName',
    dataIndex: 'amazonName',
    key: 'amazonName',
  },
  // {
  //   title: 'Active Commission',
  //   dataIndex: 'commissionRate',
  //   key: 'commissionRate',
  // },
  {
    title: 'Associate Status',
    dataIndex: 'associateStatus',
    key: 'associateStatus',
  },
  {
    title: 'ACC Authorization',
    dataIndex: 'ccAuthorizationStatus',
    key: 'ccAuthorizationStatus',
  },
])
const itemData = ref({})
// Define events
const emit = defineEmits([
  'pageChange',
  'search',
  'selectChange',
  'tableChange',
  'change',
  'goNext',
  'goBack',
])
const handleChangeAuthorizationStatus = (record) => {
  if(!isAcc.value) return

  // 打开新窗口并传递品牌ID
  window.open(`/seller/creatorConnections/authorization?brand=true`)
  // router.push({
  //   path: '/seller/creatorConnections/authorization',
  //   query: {
  //     brand: true,
  //   },
  // })
}
// 选择变化处理函数
const onSelectChange = (keys, selectedRows) => {
  // 更新当前页面选中项
  selectedRowKeys.value = keys

  // 更新全局选择集合和品牌数据
  selectedRowKeys.value = keys
  const currentPageBrandIds = dataSource.value.map((item) => item.id)
  currentPageBrandIds.forEach((brandId) => {
    if (keys.includes(brandId)) {
      // 如果品牌在选中列表中，添加到全局选择
      const row = dataSource.value.find((item) => item.id === brandId)
      if (row) {
        allSelectedKeys.value.add(brandId)
        allSelectedBrands.value.set(brandId, row)
      }
    } else {
      // 如果品牌不在选中列表中，从全局选择中移除
      allSelectedKeys.value.delete(brandId)
      allSelectedBrands.value.delete(brandId)
    }
  })

  // // 限制最大选择数量为100项
  // if (allSelectedKeys.value.size > 100) {
  //   message.error('Maximum 100 brands can be selected')

  //   // 保留前100个选中项
  //   const limitedKeys = Array.from(allSelectedKeys.value).slice(0, 100)
  //   allSelectedKeys.value = new Set(limitedKeys)

  //   // 更新品牌数据映射
  //   allSelectedBrands.value = new Map(
  //     Array.from(allSelectedBrands.value).filter(([key]) =>
  //       limitedKeys.includes(key),
  //     ),
  //   )

  //   // 更新当前页面显示
  //   selectedRowKeys.value = limitedKeys.filter((key) => {
  //     return selectedRows.some((row) => row.brandId === key)
  //   })
  // }
}

const dataSource = ref([])
const brandList = ref([])
const value5 = ref('')

const onSearch = () => {
  getBrandsList()
}

// 获取品牌列表
const getBrandsList = async (value) => {
  loading.value = true
  let res
  try {
    if (props.type === 'multiple') {
      res = await brandApi.getAssociateBrandList({
        page: pagination.value.current,
        size: pagination.value.pageSize,
        amazonUserId: amazonUserId,
        keyword: value5.value,
        associateStatus:
          filter.value.associateBrandProgress === 'All'
            ? undefined
            : filter.value.associateBrandProgress === 'Active'
            ? 'ACTIVE'
            : 'INACTIVE',
        ccAuthorizationStatus:
          filter.value.accAuthorization === 'All'
            ? undefined
            : filter.value.accAuthorization === 'Authorized'
            ? 'authorized'
            : 'unauthorized',
      })
     
    }

    if (res.success) {
      const brandNameCount = countBrandNames(res.data?.data, 'amazonBrandName')
      const newData = res.data?.data?.map((item) => {
        return {
          ...item,
          hasDuplicate:
            item.amazonBrandName && brandNameCount[item.amazonBrandName] > 1,
        }
      })
      // const newData = []
      
      // 更新数据源
      dataSource.value = newData

      // 更新当前页面选中状态
      const currentPageIds = newData.map((item) => item.id)
      selectedRowKeys.value = Array.from(allSelectedKeys.value).filter((key) =>
        currentPageIds.includes(key),
      )

      // 更新已选中品牌的数据（确保数据是最新的）
      newData.forEach((item) => {
        if (allSelectedKeys.value.has(item.id)) {
          allSelectedBrands.value.set(item.id, item)
        }
      })

      pagination.value.total = res.data.total
    } else {
      message.error(res.error)
    }
  } catch (error) {
    console.log(error, 'err')
    message.error('Failed to get data', error)
  } finally {
    loading.value = false
  }
}

const onTableChange = ({ current, pageSize }) => {
  pagination.value.current = current

  pagination.value.pageSize = pageSize
  getBrandsList({ page: current, size: pageSize })
}
const onPageChange = (current) => {
  pagination.value.current = current
  getBrandsList()
}
const handleChange = (value) => {
  pagination.value.current = 1
  getBrandsList(value)
}

// 下一步处理函数
const goNext = () => {
  // 获取所有选中品牌的完整数据
  const selectedBrands = Array.from(allSelectedBrands.value.values())
  const selectedIds = Array.from(allSelectedKeys.value)
  emit('goNext', selectedBrands, selectedIds, 1)
}
const goBack = () => {
  emit('goBack')
}
onMounted(() => {
  amazonUserId = brandStore?.params?.amazonUserId
  itemData.value = JSON.parse(sessionStorage.getItem('publisherDetail'))

  getBrandsList()
})
</script>

<style scoped lang="less">
.box{
     padding:0 16px 16px;
}
.wenhao {
  color: rgba(245, 155, 0, 1);
}
.next-button{
  height: 32px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}
.popover-content {
  .popover-title {
    font-family: Sora;
    font-weight: 600;
    font-style: SemiBold;
    font-size: 13px;
    color: rgba(15, 6, 41, 1);
  }
  .popover-content-text {
    margin: 21px 0;
    font-family: Sora;
    font-weight: 400;
    font-style: Regular;
    font-size: 13px;
    color: rgba(15, 6, 41, 1);
  }
  .popover-bottom-text {
    background-color: rgba(248, 247, 252, 1);
    border-radius: 8px;
    padding: 12px 16px;
    height: 88px;
  }
  .popover-bottom-text-bottom {
    p {
      font-family: Sora;
      font-weight: 400;
      font-style: Regular;
      font-size: 13px;
      color: rgba(15, 6, 41, 1);
    }
  }
  .popover-bottom-text-top {
    display: flex;
    align-items: center;
    font-family: Sora;
    font-weight: 600;
    font-style: SemiBold;
    font-size: 13px;
    color: rgba(108, 61, 242, 1);
  }
  .popover-bottom-text-content {
    background-color: rgba(248, 247, 252, 1);
    border-radius: 8px;
    height: 70px;
    padding: 12px 16px;
    margin-top: 21px;
  }
}
.bottomFixButton {
  display: flex;
  align-items: center;
  gap: 20px;
}
.top {
  padding: 20px 16px;
  background-color: #fff;
  border-radius: 8px;
  margin-top: 20px;

  .bottom {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-top: 16px;

    .bottom-title {
      font-family: Sora;
      font-weight: 500;
      font-style: Medium;
      font-size: 18px;
      color: #0f0629;
    }
  }
}

.content {
  background-color: #fff;
  border-radius: 8px;
  margin-top: 16px;
  padding: 20px 16px;
}

.title {
  font-family: Sora;
  font-weight: 600;
  font-size: 20px;
  color: #0f0629;
  padding-bottom: 16px;
  border-bottom: 1px solid #e8e5ed;
}

.table {
  margin-bottom: 64px;
}

.table-head {
  display: flex;
  height: 64px;
  justify-content: space-between;
  align-items: center;
  padding: 32px 0;
}

.filters {
  display: flex;
  gap: 22px;
  padding: 15px 16px;
  margin: 16px 0;
  border-radius: 8px;
  background: #f8f7fc;

  .filter-item {
    .label {
      color: #0f0629;
      font-family: 'Sora';
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      margin-bottom: 8px;
      opacity: 0.9;
    }
  }
}

.table-content {
  // Table content styles if needed
}
.ccAuthorizationStatus-content{
  display: flex;
  align-items: center;
  gap: 0px;
}
.ccAuthorizationStatus {
  display: flex;
  align-items: center;
}
.tiaozhuanicon {
  color: rgba(139, 133, 156, 1);
  // cursor: pointer;
}
.brand-item {
  display: flex;
  align-items: center;
  gap: 10px;
}

.bottomFix {
  position: sticky;
  bottom: 0px;
  height: 64px;
  border: 1px solid #e8e5ed;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
z-index: 999;

}

.total {
  font-family: Sora;
  font-weight: 400;
  font-style: Regular;
  font-size: 14px;
  color: rgba(15, 6, 41, 1);
}

.totalStyle {
  font-family: Sora;
  font-weight: 400;
  font-style: Regular;
  font-size: 12px;
  color: rgba(15, 6, 41, 0.5);
}

.bottomFixContent {
  font-family: Sora;
  font-weight: 400;
  font-style: Regular;
  font-size: 14px;
  display: flex;
  align-items: center;

  .icon {
    margin: 2px 2px 0;
    font-size: 16px;
  }
}
</style>
